import { readable } from 'svelte/store';
export const options = {
    profile:"audit", //audit for prod
    home:"/dashboard",
    firebase : {
        apiKey: "AIzaSyAe2Fuk6vAuKl_E1FhM_NpKBt5fAraOK-0",
        authDomain: "base2-63ddb.firebaseapp.com",
        projectId: "base2-63ddb"
    
    },
    form0:{
        api:"https://nl55d79e6l.execute-api.ap-southeast-2.amazonaws.com/dev/v3/",
        options : {
            redirect:true, //allow server side redirects
            messages:true, //allow serverside messages
            redirectOnAuth:"/login"
        }
    }
}